module.exports = __webpack_public_path__ + "static/img/logo_login.7918108b.png";